import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

class Contact extends Component {

    handleChange(e) {
        let form = this.state.form;
        let name = e.target.name;
        if(name=='typesp'){
            name='type'
        }
        form[name] = e.target.value;
        this.setState({form: form});
    }

    constructor(props) {
        super(props);
        this.state = {
            form: {
                name: '',
                email: '',
                type: '',
                content: ''
            }
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        console.log('mount');
        if( this.props.match.params.type ){
            let form = this.state.form;
            form.type = this.props.match.params.type;
            this.setState({form: form});
        }
    }

    send = () => {
        let form = this.state.form;
        let api = process.env.REACT_APP_API_URL + '/contact?key=' + process.env.REACT_APP_API_KEY;
        const method = "POST";
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        };
        let body = Object.keys(form).map((key)=>key+"="+encodeURIComponent(form[key])).join("&");
        fetch(api, {method,headers,body}).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson);
            if( responseJson.status == 'success' ){
                alert('お問い合わせを送信しました。');
            } else {
                let message = responseJson.message+'\n';
                for(let k in responseJson.error_a){
                    message += '\n'+responseJson.error_a[k];
                }
                alert(message);
            }
        });
    };

    render() {
        return (
            <div>
                <Header/>
                <div className="content partslist-page">
                    <div className="container">
                        <div className="title-partslist-page">
                            お問い合わせ
                        </div>
                        <div className="img-three-dot">
                            <img src="/images/three-dot.png" className="img-fluid"/>
                        </div>
                        <div className="description-item-parts">
                            内容によっては回答をさしあげるのにお時間をいただくこともございます。<br/>
                            また、休業日は翌営業日以降の対応となりますのでご了承ください。
                        </div>
                        <div className="h2-tag-parts">
                            <img src="/images/icon_03.png" className="img-fluid"/>
                            <span>お問い合わせフォーム</span>
                        </div>
                        <div className="table-parts-page pt-3">
                            <table className="table table-parts">
                                <tbody>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                名前
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form-group">
                                            <input type="text" name="name" className="form-control form-input-3" placeholder="差入 太郎"
                                                   value={this.state.form.name} onChange={this.handleChange}/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                メールアドレス
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form-group">
                                            <input type="text" name="email" className="form-control form-input-3" placeholder="info@sashiire.jp"
                                                   value={this.state.form.email} onChange={this.handleChange}/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                お問い合わせ種類
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="clearfix ml-2">
                                            <div className="float-left">
                                                <label className="label-radio mr-4">
                                                    <input name="type" type="radio"
                                                           checked={this.state.form.type=='club'}
                                                           value="club" onChange={this.handleChange}/>
                                                    <span className="checkmark"></span>
                                                    部活
                                                </label>
                                            </div>
                                            <div className="float-left ml-4 form-check">
                                                <label className="label-radio">
                                                    <input name="type" type="radio"
                                                           checked={this.state.form.type=='company'}
                                                           value="company" onChange={this.handleChange}/>
                                                    <span className="checkmark"></span>
                                                    企業
                                                </label>
                                            </div>
                                            <div className="float-left ml-4 form-check">
                                                <label className="label-radio">
                                                    <input name="type" type="radio"
                                                           checked={this.state.form.type=='other'}
                                                           value="other" onChange={this.handleChange}/>
                                                    <span className="checkmark"></span>
                                                    その他
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                お問い合わせ内容
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="textarea">
                                                <textarea name="content" className="form-control" rows="6" value={this.state.form.content} onChange={this.handleChange}></textarea>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table className="table table-parts-mb">
                                <tbody>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                名前
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="form-group formgroup-mb-parts-3 mt-3">
                                            <input type="text" name="name" className="form-control form-input-3" placeholder="差入 太郎"
                                                   value={this.state.form.name} onChange={this.handleChange}/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                メールアドレス
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="form-group formgroup-mb-parts-3 mt-3">
                                            <input type="text" name="email" className="form-control form-input-3" placeholder="info@sashiire.jp"
                                                   value={this.state.form.email} onChange={this.handleChange}/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                お問い合わせ種類
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="form-check">
                                            <label className="label-radio mr-4">
                                                <input name="typesp" type="radio" value="club"
                                                       checked={this.state.form.type=='club'}
                                                       onChange={this.handleChange}/>
                                                <span className="checkmark"></span>
                                                部活
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <label className="label-radio">
                                                <input name="typesp" type="radio" value="company"
                                                       checked={this.state.form.type=='company'}
                                                       onChange={this.handleChange}/>
                                                <span className="checkmark"></span>
                                                企業
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <label className="label-radio">
                                                <input name="typesp" type="radio" value="other"
                                                       checked={this.state.form.type=='other'}
                                                       onChange={this.handleChange}/>
                                                <span className="checkmark"></span>
                                                その他
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                お問い合わせ内容
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="textarea">
                                            <textarea name="content" className="form-control" rows="6" value={this.state.form.content} onChange={this.handleChange}></textarea>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="div-btn-confirm-partslist">
                            <a onClick={this.send}>
                                <div className="button-confirm-partslist">
                                    送信する
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Contact